<template>
  <div class="wraper">
    <el-row class="top">
      <span>设备报表</span>
      <el-tooltip placement="right">
        <div slot="content">
          设备报表：以设备为维度，对设备统一查看管理
          <br />累计客流：所有大数据冷柜客流量总和(开关门次数-补货次数)
          <br />平均日客流：此设备平均每天客流量
          <br />平均纯净度：此设备纯净度平均值
          <br />累计销售额：此设备售额量总和(排除补货、退货状态后，各商品销售数量*对应单价后金额总和)
          <br />平均销售额：此设备平均每天额销售额
          <br />累计销量：此设备销量总和(排除补货、退货状态后，各商品销售数量总和）
          <br />平均销量：此设备平均每天销售额
        </div>
        <i class="el-icon-question"></i>
      </el-tooltip>
      <el-date-picker
        size="mini"
        v-model="date"
        type="daterange"
        align="right"
        unlink-panels
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :clearable="clearDate"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-button size="mini" type="primary" @click="search">查询</el-button>
      <div class="export_btn">
        <exporter
          :setting="setting"
          :postParams="postParams"
          :url="getListUrl"
          :date="date"
          :exportName="exportName"
        ></exporter>
      </div>
    </el-row>
    <deviceSearchBox
      :postParams="postParams"
      @getSearchSelect="searchTable"
    ></deviceSearchBox>
    <el-row>
      <report
        :setting="setting"
        :list="list"
        :date="date"
        @changeSort="handleSun"
      ></report>
      <el-row class="pages">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import Report from "../../components/Report";
import exporter from "../../components/exporter";
import deviceSearchBox from "../devices/components/deviceSearchBox";

export default {
  name: "device",
  components: {
    Report,
    exporter,
    deviceSearchBox
  },
  data() {
    return {
      getListUrl: "data/getDataReport_AssetsList",
      date: this.getDefaultDay(),
      clearDate: false,
      exportName: "设备报表",
      postParams: {
        areaCompanyId: "",
        provinceBranchCompanyId: "",
        productModelType: "",
        agencyType: "",
        channelType: "",
        secondChannelType: "",
        thirdChannelType: "",
        dealerCompanyId: "",
        cityCode: "",
        marketType: "",
        provinceCode: "",
        putPolicy: "",
        storeId: "",
        keyWord: ""
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 1000 * 60 * 60 * 24;
        },
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近七天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      currentPage: 1,
      setting: {
        isShowSelect: false,
        isShowIndex: false,
        tHeader: [
          {
            dataItem: "areaCompanyName",
            dataName: "大区",
            width: "120px"
          },
          {
            dataItem: "provinceBranchCompanyName",
            dataName: "省区/分公司",
            width: "160px"
          },
          {
            dataItem: "productModelType",
            dataName: "冷柜系列",
            width: "120px"
          },
          {
            dataItem: "channelTypeName",
            dataName: "渠道类型",
            width: "120px"
          },
          {
            dataItem: "secondChannelTypeName",
            dataName: "二级渠道类型",
            width: "140px"
          },
          {
            dataItem: "thirdChannelTypeName",
            dataName: "三级渠道类型",
            width: "140px"
          },
          {
            dataItem: "marketTypeName",
            dataName: "市场类型",
            width: "120px"
          },
          {
            dataItem: "dealerCompanyName",
            dataName: "经销商名称",
            width: "200px"
          },
          {
            dataItem: "storeName",
            dataName: "网点名称",
            width: "200px"
          },
          {
            dataItem: "agencyTypeName",
            dataName: "客户类型",
            width: "200px"
          },
          {
            dataItem: "provinceName",
            dataName: "省份",
            width: "100px"
          },
          {
            dataItem: "cityName",
            dataName: "城市",
            width: "100px"
          },
          {
            dataItem: "putPolicyName",
            dataName: "返款政策",
            width: "300px"
          },
          {
            dataItem: "lastCheckRecord",
            dataName: "最后巡检日期",
            width: "200px"
          },
          {
            dataItem: "assetsNum",
            dataName: "资产编号",
            width: "200px"
          },
          {
            dataItem: "onlineStatus",
            dataName: "通信状态",
            width: "150px"
          },
          {
            dataItem: "sumCustomerFlow",
            dataName: "累计客流/人",
            width: "150px"
          },
          {
            dataItem: "avgCustomerFlow",
            dataName: "平均客流/人",
            width: "150px"
          },
          {
            dataItem: "avgPurity",
            dataName: "平均专放率/%",
            width: "160px"
          },
          {
            dataItem: "sumSalesNum",
            dataName: "累计销量/个",
            width: "150px"
          },
          {
            dataItem: "avgSalesNum",
            dataName: "平均销量/个",
            width: "150px"
          },
          {
            dataItem: "sumSalesAmount",
            dataName: "累计销售额/元",
            width: "160px"
          },
          {
            dataItem: "avgSalesAmount",
            dataName: "平均销售额/元",
            width: "160px"
          }
        ],
        isShowPlay: true,
        isShowDelBtn: false,
        isShowEditBtn: false,
        isShowInfoBtn: true,
        isshowGoodsBtn: true,
        btnsWidth: "200px",
        infoUrl: "deviceDetail"
      },
      list: [],
      total: 0,
      pageSize: 10
    };
  },
  mounted() {
    this.getList();
  },
  methods: {

    getDefaultDay() {
      let date = new Date();
      let startdate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * 8);
      let startyear = startdate.getFullYear();
      let startmonth = startdate.getMonth() + 1;
      if (startmonth < 10) {
        startmonth = "0" + startmonth;
      }
      let startday = startdate.getDate();
      if (startday < 10) {
        startday = "0" + startday;
      }
      startdate = startyear + "-" + startmonth + "-" + startday;
      let enddate = new Date(date.getTime() - 1000 * 60 * 60 * 24);
      let endyear = enddate.getFullYear();
      let endmonth = enddate.getMonth() + 1;
      if (endmonth < 10) {
        endmonth = "0" + endmonth;
      }
      let endday = enddate.getDate();
      if (endday < 10) {
        endday = "0" + endday;
      }
      enddate = endyear + "-" + endmonth + "-" + endday;
      return [startdate, enddate];
    },
    getList(val) {

      let url = this.getListUrl;
      let paramsObj = this.postParams;
      let params = {
        startDay: this.date[0],
        endDay: this.date[1],
        pageSize: this.pageSize,
        pageNum: this.currentPage
      };
      if (val != undefined) {
        params.order = val.order;
        params.prop = val.prop;
      }
      for (let k in paramsObj) {
        if (paramsObj[k] != "") params[k] = paramsObj[k];
      }

      let _this = this;
      this.$ajax
        .post(url, params)
        .then(this.getListSucc)
        .catch(function(res) {
          _this.$message.error("哎呀~网络异常了呢");
        });
    },
    getListSucc(res) {
      if (res.data && res.data.code === 200) {
        const data = res.data.data
        this.list = data.list
        this.list.forEach((item, index) => {
          console.log(item.onlineStatus)
          switch (item.onlineStatus) {
            case 0:
              item.onlineStatus = '离线'
              break;
            // eslint-disable-next-line no-fallthrough
            case 1:
              item.onlineStatus = '在线'
              break;
            default:
              break;
          }
          // console.log(this.list);
        })
        this.total = data.total
        
      } else {
        let errMsg = "未知错误";
        if (res.data.msg) {
          errMsg = res.data.msg;
        }
        this.$message.error(errMsg);
      }
    },
    search() {
      this.getList();
    },
    handleSizeChange(val) {
      // console.log('每页 '+val+' 条');
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
      // console.log(this.pageSize);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    handleSun(val) {
      this.getList(val);
    },
    searchTable() {
      //console.log(this.postParams)
      this.getList();
    }
  }
};
</script>
<style scoped>
.top {
  height: 50px;
}

.pages {
  padding-top: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/reports/device.vue